import React from "react";

const TermsOfUsePage = () => {
  return (
    <div className="sub-page">
      <div className="sub-page__container">
        <h2 className="h2">Terms of Use for Eleganto</h2>
        <h4 className="h4">Introduction</h4>
        <p className="text">
          Welcome to Eleganto, your premier online booking platform for manicure and pedicure services at Mon Lis salons
          in Munich. By accessing or using our web application, you agree to be bound by these Terms of Use. Service
          Description
        </p>
        <p className="text">
          Eleganto provides a user-friendly platform for booking manicure and pedicure appointments online with Mon Lis
          salons in Munich.
        </p>
        <h4 className="h4">User Obligations</h4>
        <ul>
          <li>
            Provide accurate and complete information about yourself, including your name, surname, email, and phone
            number.
          </li>
          <li>Use the service for personal, non-commercial purposes only.</li>
          <li>Comply with all local laws and regulations regarding online conduct and acceptable content.</li>
        </ul>

        <h4 className="h4">Prohibited Activities</h4>
        <ul>
          <li>
            Any form of abuse of the service, including but not limited to, unauthorized use of data, or attempting to
            breach security measures.
          </li>
          <li>Misrepresentation of identity or providing false information.</li>
        </ul>

        <h4 className="h4">Account Suspension or Termination</h4>
        <p className="text">
          We reserve the right to suspend or terminate accounts for violations of these terms, with or without notice.
        </p>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
